import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RichTextArea from './RichTextArea';

import validationFunctions from '../../utils/validations/index.js';
import validationMessages from '../../utils/validations/messages';

class Textarea extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    value: '',
    type: 'text',
    placeholder: '',
    maxLength: '',
    richLink: false,
  };

  state = {
    errorMessage: null,
  }

  onChange = (e) => {
    const {
      inputGroup,
      onChange,
    } = this.props;

    onChange(e.target.value,inputGroup);
  }

  onRichTextChange = value => this.props.onChange(value, this.props.inputGroup); 

  validate = (value = this.props.value, explicitErrorMessage) => {
    if(value == null){
      this.setState({
        errorMessage: explicitErrorMessage,
      });
    }

    const {
      validationRules,
      customErrorMessage
    } = this.props;

    let valid = true;
    let errorMessage = '';
    const rules= validationRules;
    const rulesList = rules && rules.split('|');
    const customErrorMessageArr = customErrorMessage && customErrorMessage.split('|');

    let errorCounter = 0;

    rulesList && rulesList.some((ruleParam, index) => {
      if (errorCounter > 0) return false;

      const ruleSplit = ruleParam.split(':');
      const rule = ruleSplit[0];
      const parameters = (ruleSplit[1] || '').split(',');


      if (validationFunctions[rule] && !validationFunctions[rule].apply(null, [value, ...parameters])) {
        errorCounter += 1;
        errorMessage = (customErrorMessageArr && customErrorMessageArr[index]) || validationMessages[rule];
        valid = valid && false;
      }

    });

    this.setState({
      errorMessage: errorMessage,
    });

    return valid;
  }

  render() {

    const {
      type,
      value,
      placeholder,
      classes,
      maxLength,
      rich,
      richLink,
    } = this.props;

    const {
      errorMessage,
    } = this.state;

    return (
      <div>
        {rich ? 
        <RichTextArea
          value={value}
          onRichTextChange={this.onRichTextChange}
          linkOption={ (richLink ? true : false) }
        />
        :
        <textarea
          type={type}
          value={value}
          onChange={this.onChange}
          placeholder={placeholder}
          className={classes}
          maxLength={maxLength}
        />}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
    );
  }
}


export default Textarea;



// WEBPACK FOOTER //
// ./src/app/components/baseComponents/textarea.js